import { useState, useEffect } from "react";
import { validateLocation, concatenateLocationKey } from "../components/helperFunction";
import { useNavigate } from "react-router-dom";
import locationsService from "services/locations-service";

import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";

import Footer from "e4acomponents/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import LocationDetails from "../components/location-details";
import LocationImage from "../components/location-image";

export default function AddLocation() {
  const [isLoading, setIsLoading] = useState(false);
  const [newLocation, setNewLocation] = useState({});
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    console.log("New Validation Errors: ", errors);
  }, [errors]);

  // Local thin wrappers that use shared helpers
  const validate = () => {
    const [ok, errs] = validateLocation(newLocation);
    setErrors(errs);
    return ok;
  };

  // Handles form submission
  const onSubmit = async (e) => {
    try {
      e.preventDefault();

      setErrors({});

      if (validate()) {
        console.log("Submitting new location:", newLocation);
      } else {
        return;
      }

      const locationKey = concatenateLocationKey(newLocation);

      const payload = {
        data: {
          attributes: {
            ...newLocation,
            locationKey: locationKey,
          }
        }
      }
      setIsLoading(true);
      // Submit the payload to the API here
      await locationsService.addLocation(payload);

      setNewLocation({});
      setErrors({});
      setIsLoading(false);
      navigate(-1);

    } catch (error) {
      console.error("Error during form submission:", error);
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>

            {/* Title */}
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  Add A New Location.
                </MDTypography>
              </MDBox>

              {/* Subtitle */}
              <MDBox>
                <MDTypography variant="h5" fontWeight="regular" color="secondary">
                  These informations will be used to describe the new location.
                </MDTypography>
              </MDBox>

            </MDBox>

            {/* Card */}
            <Card>

              {/* Form */}
              <MDBox
                component="form"
                method="POST"
                encType="multipart/form-data"
                onSubmit={onSubmit}
              >
                <MDBox display="flex" flexDirection="column" px={3} my={4}>

                  {/* Loading Spinner or Form Fields */}
                  {isLoading ? (
                    <MDBox display="flex" justifyContent="center" alignItems="center" height="84vh">
                      <CircularProgress />
                    </MDBox>
                  ) : (
                    <>
                      {/* Location Details Section */}
                      <LocationDetails
                        newLocation={newLocation}
                        setNewLocation={setNewLocation}
                        errors={errors}
                      />

                      {/* Location Image Section */}
                      <LocationImage
                        newLocation={newLocation}
                        setNewLocation={setNewLocation}
                        errors={errors}
                      />
                    </>
                  )}


                  {/* Submit & Cancel buttons */}
                  <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">

                    {/* Cancel Button */}
                    <MDBox mx={1}>
                      <MDButton
                        variant="gradient" color="dark" size="small" px={2} mx={2}
                        onClick={() => navigate(-1)}>
                        Cancel
                      </MDButton>
                    </MDBox>

                    {/* Submit Button */}
                    <MDBox mx={1}>
                      <MDButton variant="gradient" color="dark" size="small" type="submit">
                        Add
                      </MDButton>
                    </MDBox>

                  </MDBox>

                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}